/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1EmployeepostId200,
  GetApiV1EmployeepostId401,
  GetApiV1EmployeepostId404,
  GetApiV1EmployeepostId500,
  GetApiV1EmployeepostIdPathParams,
  GetApiV1EmployeepostIdQueryResponse,
} from "../../types/employeePostController/GetApiV1EmployeepostId.ts";
import { employeePostViewModelSchema } from "../employeePostViewModelSchema.ts";

export const getApiV1EmployeepostIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1EmployeepostIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1EmployeepostId200Schema = z.lazy(
  () => employeePostViewModelSchema,
) as unknown as ToZod<GetApiV1EmployeepostId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1EmployeepostId401Schema =
  z.any() as unknown as ToZod<GetApiV1EmployeepostId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1EmployeepostId404Schema =
  z.any() as unknown as ToZod<GetApiV1EmployeepostId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1EmployeepostId500Schema =
  z.any() as unknown as ToZod<GetApiV1EmployeepostId500>;

export const getApiV1EmployeepostIdQueryResponseSchema = z.lazy(
  () => getApiV1EmployeepostId200Schema,
) as unknown as ToZod<GetApiV1EmployeepostIdQueryResponse>;
